<template>
  <div id="app" class="statement-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialogfiltre" scrollable persistent max-width="510px">
      <v-card>
        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-card flat class="white--text">
            <v-card flat>
              <v-card-actions>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      hide-details
                      :items="dovizTipleri"
                      label="Ekstre Tipi"
                      item-text="text"
                      item-value="value"
                      v-model="searchParams.ExtractType"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <catimuhasebekodu
                      v-model="accoutingCode"
                      :controlValue="accoutingCode"
                      :companyID="credentials.MuhasebeSirketNo"
                      :text="$t('Start-Accounting-Code')"
                      @validateCheck="checkAccoutingValidate()"
                      :Coper="false"
                    ></catimuhasebekodu>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <catimuhasebekodu
                      v-model="endAccoutingCode"
                      :controlValue="endAccoutingCode"
                      :companyID="credentials.MuhasebeSirketNo"
                      :text="$t('End-Accounting-Code')"
                      @validateCheck="checkAccoutingValidate()"
                      :Coper="false"
                    ></catimuhasebekodu>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeClosingFiche"
                      label="Kapanış Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeOpeningFiche"
                      label="Açılış Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>
                   <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeReflectionFiche"
                      label="Yansıtma Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="filtreiptal()">
            {{ $t('cancel_button') }}
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="filtrekayit()">
            {{ $t('Apply-Filters') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar dark color="info" class="page-toolbar">
            <v-toolbar-title>{{ $t("Statement-of-Account") }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title>
                    Html {{ $t("Download") }}
                  </v-list-tile-title>
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title>
                    Excel {{ $t("Download") }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-container fluid>
          <v-form ref="muhasebehesabagore" v-model="valid">
            <v-layout row wrap>
              <v-flex xs12 sm6 md2>
                <tarihcomp
                  :etiket="$t('Starting-Date')"
                  v-bind:defaultvalue="'ok'"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  v-model="searchParams.FirstDate"
                  v-bind:value="searchParams.FirstDate"
                ></tarihcomp>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <tarihcomp
                  :etiket="$t('Finishing-Date')"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  v-bind:defaultvalue="'ok'"
                  v-model="searchParams.EndDate"
                  v-bind:value="searchParams.EndDate"
                ></tarihcomp>
              </v-flex>

              <v-flex>
                <v-layout>
                  <v-btn color="info" @click="getList()" fab small dark>
                    <v-icon>search</v-icon>
                  </v-btn>

                  <v-btn small @click="filtrele()" color="info" fab dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>

        <v-container fluid>
          <report-table
            :headers="headers"
            :items="itemDetails"
            :loading="loadingvmodel"
            :has-searched="hasSearched"
            :storage-key="'statement_of_account_report_table'"
            :search-label="$t('Search')"
            :row-class-fn="rowClassFn"
          >
            <template slot="cell" slot-scope="slotProps">
              <template v-if="slotProps.column.value === 'action'">
                <v-btn
                  v-if="slotProps.item.RecieptID != null && slotProps.item.RecieptID !== 'undefined' && !isSummaryRow(slotProps.item)"
                  color="info"
                  @click="git(slotProps.item)"
                  outline
                  fab
                  small
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </template>

              <template v-else>
                <span :class="{ 'font-weight-bold': isSummaryRow(slotProps.item) }">
                  {{ formatCellValue(slotProps.item, slotProps.column) }}
                </span>
              </template>
            </template>
          </report-table>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      dovizTipleri: [
        { text: "TL", value: 0 },
        { text: "Döviz", value: 1 },
        { text: "Döviz + TL", value: 3 }
      ],

      dialogfiltre: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      hasSearched: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      valid: true,

      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        ExtractType: 0,
        ExcludeClosingFiche: 0,
        ExcludeOpeningFiche: 0,
        ExcludeReflectionFiche:0
      },

      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null
      },

      endAccoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null
      },

      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      itemDetails: [],
      itemDetailsRoot: [],
      totalsDetails: [],
      totalTransfersDetails: [],

      headers: [
        {
          text: this.$t("Date"),
          value: "RecieptDate",
          type: "date",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Bill-No"),
          value: "RecieptNo",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "120px"
        },
        {
          text: "Satır No",
          value: "LineNo",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "110px"
        },
        {
          text: "Açıklama",
          value: "Explanation1",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "260px"
        },
        {
          text: "Evrak No",
          value: "DocumentNo",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "130px"
        },
        {
          text: this.$t("Maturity-Date"),
          value: "DueDate",
          type: "date",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: "Referans",
          value: "Referance",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "120px"
        },
        {
          text: "Masraf Merkezi",
          value: "CostCenter",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "150px"
        },
        {
          text: "TL",
          value: "TL",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "120px"
        },
        {
          text: "Döviz",
          value: "Currency",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Debit"),
          value: "Dept",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Credit"),
          value: "Credit",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Balance"),
          value: "Balance",
          type: "balance",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "150px"
        },
        {
          text: "",
          value: "action",
          type: "text",
          align: "center",
          visible: true,
          sortable: false,
          minWidth: "90px"
        }
      ]
    };
  },

  methods: {
    git(val) {
      var url = "#/muhasebe/fisler/detay/id?islem=get&fisID=" + val.RecieptID;
      window.open(url, "_blank");
    },

    filtrekayit() {
      this.dialogfiltre = false;
      this.getList();
    },

    filtreiptal() {
      this.dialogfiltre = false;
    },

    filtrele() {
      this.dialogfiltre = true;
    },

    moneyformat(m) {
      return helpers.moneyformat(m);
    },

    CheckBalance(val) {
      var rval = null;

      if (val > 0) {
        rval = this.moneyformat(val) + " B";
      } else if (val == 0) {
        rval = this.moneyformat(val);
      } else {
        rval = this.moneyformat(val * -1) + " A";
      }

      if (rval && rval.indexOf("NaN") > -1) {
        rval = rval.replace(/NaN/g, "");
      }

      return rval;
    },

    checkAccoutingValidate() {
      this.accoutingCode.CodeID = 0;
    },

    getparabirimi() {
      return helpers.getparabirimi();
    },

    isSummaryRow(item) {
      return item && item.RecieptNo == null;
    },

    rowClassFn(item) {
      if (this.isSummaryRow(item)) {
        return "report-row summary-row";
      }

      return "report-row";
    },

    isEmptyValue(val) {
      return val === null || val === undefined || val === "";
    },

    formatCellValue(item, column) {
      if (!item || !column) {
        return "";
      }

      const value = item[column.value];

      if (
        this.isSummaryRow(item) &&
        (column.value === "Dept" || column.value === "Credit" || column.value === "Balance")
      ) {
        if (item.RecieptNo == null && item.TL == null && item.Currency == null) {
          return "";
        }
      }

      if (column.value === "TL") {
        if (item.RecieptNo != null) {
          return this.isEmptyValue(value) ? "" : helpers.moneyformat(value);
        }
        return this.isEmptyValue(value) ? "" : helpers.moneyformat(value);
      }

      if (column.type === "date") {
        return this.isEmptyValue(value) ? "" : helpers.dateformat(value);
      }

      if (column.type === "money") {
        return this.isEmptyValue(value) ? "" : helpers.moneyformat(value);
      }

      if (column.type === "balance") {
        return this.isEmptyValue(value) ? "" : this.CheckBalance(value);
      }

      return this.isEmptyValue(value) ? "" : value;
    },

    buildFlatItems(extracts) {
      const result = [];

      if (!Array.isArray(extracts)) {
        return result;
      }

      for (const element of extracts) {
        if (element.AccountingCode) {
          result.push({
            Explanation1:
              (element.AccountingCode.Code || "") +
              "/" +
              (element.AccountingCode.CodeName || ""),
            RecieptNo: null,
            TL: null,
            Currency: null,
            Dept: null,
            Credit: null,
            Balance: null
          });
        }

        if (Array.isArray(element.TotalPrices)) {
          for (const transfer of element.TotalPrices) {
            result.push({
              Currency: (transfer.Currency || "") + " Devir Toplam:",
              Dept: transfer.TransferDept,
              Credit: transfer.TransferCredit,
              Balance: transfer.TransferBalance,
              TL: "",
              RecieptNo: null
            });
          }
        }

        if (Array.isArray(element.Details)) {
          for (const detay of element.Details) {
            const data = detay;
            const kalemCurrency = data.Currency;
            let debit_ = 0;
            let credit_ = 0;
            let balance_ = 0;

            if (element.Currencies && element.Currencies[0] === "" && element.Currencies.length === 1) {
              debit_ = data.Dept ? data.Dept[0] : 0;
              credit_ = data.Credit ? data.Credit[0] : 0;
              balance_ = data.Balance ? data.Balance[0] : 0;
            } else {
              const i = element.Currencies ? element.Currencies.indexOf(kalemCurrency) : -1;
              debit_ = i > -1 && data.Dept ? data.Dept[i] : 0;
              credit_ = i > -1 && data.Credit ? data.Credit[i] : 0;
              balance_ = i > -1 && data.Balance ? data.Balance[i] : 0;
            }

            result.push({
              RecieptDate: data.RecieptDate,
              RecieptNo: data.RecieptNo,
              DueDate: data.DueDate,
              LineNo: data.LineNo,
              Explanation1: data.Explanation1,
              DocumentNo: data.DocumentNo,
              Referance: "",
              CostCenter: "",
              TL: data.TL,
              Currency: data.Currency,
              Dept: debit_,
              Credit: credit_,
              Balance: balance_,
              RecieptID: data.RecieptID
            });
          }
        }

        if (Array.isArray(element.TotalPrices)) {
          for (const period of element.TotalPrices) {
            result.push({
              Currency: (period.Currency || "") + " Dönem Toplam:",
              Dept: period.PeriodDept,
              Credit: period.PeriodCredit,
              Balance: period.PeriodBalance,
              RecieptNo: null
            });
          }

          for (const total of element.TotalPrices) {
            result.push({
              Currency: (total.Currency || "") + " Genel Toplam:",
              Dept: total.TotalDept,
              Credit: total.TotalCredit,
              Balance: total.TotalBalance,
              RecieptNo: null
            });
          }
        }
      }

      return result;
    },

    validateDateRange() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      this.loadingvmodel = false;
      return false;
    },

    prepareSearchParams() {
      this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.searchParams.FirstAccountCode = this.accoutingCode.Code;
      this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
    },

    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.loadingvmodel = true;
      this.items = [];
      this.itemDetails = [];
      this.itemDetailsRoot = [];

      if (!this.$refs.muhasebehesabagore.validate()) {
        this.loadingvmodel = false;
        return;
      }

      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/ExtractAccountList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }
        )
        .then(
          (response) => {
            const body = response.body || {};

            if (body.Status === false && body.ResponseMessage != null) {
              this.text1 = body.ResponseMessage;
              this.snackbar = true;
              this.items = [];
              this.itemDetails = [];
              this.loadingvmodel = false;
              return;
            }

            const extracts = Array.isArray(body.Extracts) ? body.Extracts : [];
            this.items = extracts;
            this.itemDetails = this.buildFlatItems(extracts);
            this.itemDetailsRoot = this.itemDetails.slice();
            this.loadingvmodel = false;
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },

    getListHtml() {
      if (!this.validateDateRange()) {
        return;
      }

      this.loadingvmodel = true;
      this.items = [];
      this.itemDetails = [];

      if (!this.$refs.muhasebehesabagore.validate()) {
        this.loadingvmodel = false;
        return;
      }

      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/ExtractAccountListHtml",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/html"
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "HesapEkstre.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },

    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.loadingvmodel = true;
      this.items = [];
      this.itemDetails = [];

      if (!this.$refs.muhasebehesabagore.validate()) {
        this.loadingvmodel = false;
        return;
      }

      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/ExtractAccountListExcel",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx"
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "HesapEkstre.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    }
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    }
  },

  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
    ReportTable
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      // yetki ok
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.statement-report-page {
  background: #f5f7fb;
}

.page-toolbar {
  border-radius: 6px 6px 0 0;
}

.report-row:hover {
  background: #f8fbff;
}

.summary-row {
  background: whitesmoke !important;
}

.summary-row td {
  font-weight: 700;
}

@media (max-width: 960px) {
  .statement-report-page {
    overflow-x: hidden;
  }
}
</style>